import inherited from 'mastodon/locales/br.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
